import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { PreferencesService } from '../../../preferences.service';
import { SubPerfilStruct } from '../../services/structs/pessoa/pessoa.struct';
import { UserLoginResponse } from '../../services/responses/pessoa.response';
import { RoutesService } from '../../../routes.service';
import { Component, OnInit, OnDestroy, Input, Output, ChangeDetectorRef } from '@angular/core';
import EventEmitter from 'events';
import { resolveActiveSubPerfil } from './subperfil-match';

@Component({
    selector: 'app-mini-subheader',
    imports: [MatProgressSpinnerModule],
    templateUrl: './mini-subheader.component.html',
    styleUrl: './mini-subheader.component.css'
})
export class MiniSubheaderComponent implements OnInit, OnDestroy {
    @Input() listSubperfil: SubPerfilStruct[] = [];
    subPerfil: SubPerfilStruct | undefined;
    isAddPage: boolean = false;
    isEditPage: boolean = false;
    isHome: boolean = false;

    @Output() valueChanged = new EventEmitter<any>();

    private routerEventsSub!: Subscription;
    public userLoginResponse: UserLoginResponse;

    constructor(
        private router: Router,
        private PreferenceService: PreferencesService,
        private routesService: RoutesService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.setPageFlags(this.router.url);
        this.routerEventsSub = this.router.events
            .pipe(
                filter((event): event is NavigationEnd => event instanceof NavigationEnd)
            )
            .subscribe((event: NavigationEnd) => {
                this.setPageFlags(event.urlAfterRedirects);
                // Este componente vive sob o MenuComponent (OnPush): sem marcar a
                // cadeia como suja, o tick global pula o pai e o breadcrumb fica
                // "preso" no valor anterior até outra interação sujar o menu.
                this.cdr.markForCheck();
            });
    }

    private setPageFlags(url: string): void {
        this.isAddPage = url.includes('/novo');
        this.isEditPage = url.includes('/editar');
        this.isHome = url.includes('/home');

        // Reatribui sempre (inclusive undefined) para não reter o subperfil da
        // página anterior; escolhe o match mais específico via fronteira de segmento.
        this.subPerfil = resolveActiveSubPerfil(url, this.listSubperfil);
    }

    navigateToBasePath() {
        let url = this.router.url;
        url = url.replace(/\/(novo|editar).*/, '');
        this.routesService.smartNavigate(url);
    }

    onToggleSubheader(): void {
        this.PreferenceService.toggleSubheaderState();
    }

    ngOnDestroy(): void {
        this.routerEventsSub?.unsubscribe();
    }
}
